import { render, staticRenderFns } from "./ConfirmInvoiceSentModal.vue?vue&type=template&id=25a12f5b&scoped=true&"
import script from "./ConfirmInvoiceSentModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmInvoiceSentModal.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmInvoiceSentModal.vue?vue&type=style&index=0&id=25a12f5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a12f5b",
  null
  
)

export default component.exports